// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.styles_pageContainer__Go5RS {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.styles_title__lx\\+v9 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1rem;
}

.styles_title__lx\\+v9 h2 {
  font-family: "Inter";
  font-size: 16px;
  color: #18316e;
}

.styles_containerSection__hYzhc {
  align-items: center;
  width: 25rem;
  gap: 1.5rem;
  display: flex;
  flex-direction: column;
  padding: 0;
}


.styles_container__u-Zwa {
  display: flex !important;
  justify-content: left !important;
  align-items: center !important;
  margin-bottom: 44px !important;
}

.styles_titulo__WukcG {
  font-family: "Inter" !important;
  font-size: 16px !important;
  color: #18316e !important;
}

.styles_formContent__Xrznm {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  height: 100vh;
}

.styles_textCodig__xs-9D {
  width: 75%;
  display: flex;
  gap: 0.5rem;
}


.styles_labelField__9QHzO {
  font-family: "Inter";
  font-size: 12px;
}

.styles_textoConfirmacao__rdvSN {
  color: #cf0e0e !important;
  font-family: "Inter" !important;
  font-size: 12px !important;
  display: none !important;
}

.styles_textoNovoCodigo__qGDvw {
  color: #000000 !important;
  font-family: "Inter" !important;
  font-size: 12px !important;
}

.styles_botaoCliqueAqui__R3vue {
  font-size: 12px !important;
  background-color: transparent !important;
  text-transform: none !important;
  padding: 0 !important;
  margin-right: 0.2rem !important;
}


.styles_container__buttons__WdBzD {
  gap: 1rem;
  justify-content: space-between;
  flex-wrap: wrap-reverse;
  display: flex;
}

.styles_botao__limpar__kcWA6 {
  border: 1px solid #18316e !important;
  color: #18316e !important;
  background-color: transparent !important;
}

.styles_botao__enviar__6wBgd {
  background-color: #18316e !important;
}

.styles_botao__limpar__kcWA6,
.styles_botao__enviar__6wBgd {
  width: 10rem !important;
  transition: transform 0.3s ease-in-out !important;
}

.styles_botao__enviar__6wBgd:hover {
  background-color: #18316e !important;
  transform: scale(0.95) !important;
}

.styles_botao__limpar__kcWA6:hover {
  transform: scale(0.95) !important;
  background-color: transparent !important;
}

@media (max-width: 426px) {
  .styles_containerSection__hYzhc {
    width: 75vw;
  }

  .styles_container__buttons__WdBzD {
    justify-content: center;
    gap: 0.5rem
  }

  .styles_botao__limpar__kcWA6,
  .styles_botao__enviar__6wBgd {
    width: 100% !important;
  }

  .styles_textCodig__xs-9D {
    width: 110%;
    gap: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ValidacaoCodigoEmail/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,UAAU;AACZ;;;AAGA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,WAAW;AACb;;;AAGA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,wCAAwC;EACxC,+BAA+B;EAC/B,qBAAqB;EACrB,+BAA+B;AACjC;;;AAGA;EACE,SAAS;EACT,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,wCAAwC;AAC1C;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;IACvB;EACF;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,MAAM;EACR;AACF","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n.pageContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n.title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 1rem;\n}\n\n.title h2 {\n  font-family: \"Inter\";\n  font-size: 16px;\n  color: #18316e;\n}\n\n.containerSection {\n  align-items: center;\n  width: 25rem;\n  gap: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n}\n\n\n.container {\n  display: flex !important;\n  justify-content: left !important;\n  align-items: center !important;\n  margin-bottom: 44px !important;\n}\n\n.titulo {\n  font-family: \"Inter\" !important;\n  font-size: 16px !important;\n  color: #18316e !important;\n}\n\n.formContent {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  align-items: center;\n  height: 100vh;\n}\n\n.textCodig {\n  width: 75%;\n  display: flex;\n  gap: 0.5rem;\n}\n\n\n.labelField {\n  font-family: \"Inter\";\n  font-size: 12px;\n}\n\n.textoConfirmacao {\n  color: #cf0e0e !important;\n  font-family: \"Inter\" !important;\n  font-size: 12px !important;\n  display: none !important;\n}\n\n.textoNovoCodigo {\n  color: #000000 !important;\n  font-family: \"Inter\" !important;\n  font-size: 12px !important;\n}\n\n.botaoCliqueAqui {\n  font-size: 12px !important;\n  background-color: transparent !important;\n  text-transform: none !important;\n  padding: 0 !important;\n  margin-right: 0.2rem !important;\n}\n\n\n.container__buttons {\n  gap: 1rem;\n  justify-content: space-between;\n  flex-wrap: wrap-reverse;\n  display: flex;\n}\n\n.botao__limpar {\n  border: 1px solid #18316e !important;\n  color: #18316e !important;\n  background-color: transparent !important;\n}\n\n.botao__enviar {\n  background-color: #18316e !important;\n}\n\n.botao__limpar,\n.botao__enviar {\n  width: 10rem !important;\n  transition: transform 0.3s ease-in-out !important;\n}\n\n.botao__enviar:hover {\n  background-color: #18316e !important;\n  transform: scale(0.95) !important;\n}\n\n.botao__limpar:hover {\n  transform: scale(0.95) !important;\n  background-color: transparent !important;\n}\n\n@media (max-width: 426px) {\n  .containerSection {\n    width: 75vw;\n  }\n\n  .container__buttons {\n    justify-content: center;\n    gap: 0.5rem\n  }\n\n  .botao__limpar,\n  .botao__enviar {\n    width: 100% !important;\n  }\n\n  .textCodig {\n    width: 110%;\n    gap: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `styles_pageContainer__Go5RS`,
	"title": `styles_title__lx+v9`,
	"containerSection": `styles_containerSection__hYzhc`,
	"container": `styles_container__u-Zwa`,
	"titulo": `styles_titulo__WukcG`,
	"formContent": `styles_formContent__Xrznm`,
	"textCodig": `styles_textCodig__xs-9D`,
	"labelField": `styles_labelField__9QHzO`,
	"textoConfirmacao": `styles_textoConfirmacao__rdvSN`,
	"textoNovoCodigo": `styles_textoNovoCodigo__qGDvw`,
	"botaoCliqueAqui": `styles_botaoCliqueAqui__R3vue`,
	"container__buttons": `styles_container__buttons__WdBzD`,
	"botao__limpar": `styles_botao__limpar__kcWA6`,
	"botao__enviar": `styles_botao__enviar__6wBgd`
};
export default ___CSS_LOADER_EXPORT___;
